export const Organizations = {
    "01G682MQPFM8K0SAPMSZP3WQ3Q": {
        title: "Abroadworks",
        slug: "abroadworks",
        logo: {
            url: "/images/abroadworks-logo.svg",
            thumbnail: "/images/abroadworks-thumbnail-logo.svg"
        }
    }
}


export enum OrganizationRegistry {
    "ABROADWORKS" = "01G682MQPFM8K0SAPMSZP3WQ3Q"
}